import { Ruler } from '@phosphor-icons/react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';

export function ProductSizeGuide({ sizes, selectedSize }) {
    const SIZE_DATA = [
        { s: 'XS', chest: '36"', length: '26"', sleeve: '32"' },
        { s: 'S', chest: '38"', length: '27"', sleeve: '33"' },
        { s: 'M', chest: '40"', length: '28"', sleeve: '34"' },
        { s: 'L', chest: '42"', length: '29"', sleeve: '35"' },
        { s: 'XL', chest: '44"', length: '30"', sleeve: '36"' },
        { s: 'XXL', chest: '46"', length: '31"', sleeve: '37"' },
    ];

    return (
        <Dialog>
            <DialogTrigger asChild>
                <button className="text-[10px] text-primary hover:underline flex items-center gap-1" data-testid="size-guide-trigger">
                    <Ruler size={12} />Size Guide
                </button>
            </DialogTrigger>
            <DialogContent className="bg-card border-border max-w-sm" data-testid="size-guide-dialog">
                <DialogHeader>
                    <DialogTitle className="font-display">Size Guide</DialogTitle>
                </DialogHeader>
                <div className="overflow-x-auto">
                    <table className="w-full text-xs">
                        <thead>
                            <tr className="border-b border-border">
                                <th className="text-left py-2 px-2 text-muted-foreground font-display">Size</th>
                                <th className="text-center py-2 px-2 text-muted-foreground font-display">Chest</th>
                                <th className="text-center py-2 px-2 text-muted-foreground font-display">Length</th>
                                <th className="text-center py-2 px-2 text-muted-foreground font-display">Sleeve</th>
                            </tr>
                        </thead>
                        <tbody>
                            {SIZE_DATA.filter(r => sizes.includes(r.s)).map(r => (
                                <tr key={r.s} className={`border-b border-border/30 ${selectedSize === r.s ? 'bg-primary/5' : ''}`}>
                                    <td className="py-2 px-2 font-bold text-foreground">{r.s}</td>
                                    <td className="text-center py-2 px-2 text-muted-foreground">{r.chest}</td>
                                    <td className="text-center py-2 px-2 text-muted-foreground">{r.length}</td>
                                    <td className="text-center py-2 px-2 text-muted-foreground">{r.sleeve}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <p className="text-[10px] text-muted-foreground mt-2">Measurements in inches. Oversized fit — size down for a slimmer look.</p>
            </DialogContent>
        </Dialog>
    );
}
